import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DentistService {

  private base = `${environment.Server_URL}/primary-registrations`;

  constructor(private http: HttpClient) { }

  // ===============================
  // GET list (pagination)
  // ===============================
  getAll(perPage = 10, page = 1): Observable<any> {
    return this.http.get<any>(
      `${this.base}?per_page=${perPage}&page=${page}`
    );
  }

  // ===============================
  // GET single
  // ===============================
  getById(id: number): Observable<any> {
    return this.http.get<any>(`${this.base}/${id}`);
  }

  // ===============================
  // CREATE
  // ===============================
  create(payload: any | FormData): Observable<any> {
    return this.http.post<any>(this.base, payload);
  }

  // ===============================
  // UPDATE (supports FormData)
  // ===============================
  update(id: number, payload: any | FormData): Observable<any> {
    const isFormData = payload instanceof FormData;

    if (isFormData) {
      payload.append('_method', 'PUT'); // Laravel trick
      return this.http.post<any>(`${this.base}/${id}`, payload);
    }

    return this.http.put<any>(
      `${this.base}/${id}`,
      payload,
      { headers: { 'Content-Type': 'application/json' } }
    );
  }

  // ===============================
  // DELETE
  // ===============================
  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.base}/${id}`);
  }

  // ===============================
  // SEARCH (optional – لو هتزودها في backend)
  // ===============================
  search(
    q = '',
    specialty?: string,
    scfhsStatus?: string,
    page = 1,
    perPage = 10
  ): Observable<any> {

    let params = new HttpParams()
      .set('page', page)
      .set('per_page', perPage);

    if (q) params = params.set('q', q);
    if (specialty) params = params.set('specialty', specialty);
    if (scfhsStatus) params = params.set('scfhs_status', scfhsStatus);

    return this.http.get<any>(`${this.base}/search`, { params });
  }
}
